// ─────────────────────────────────────────────────────────────────────────────
// DonutChart.js — traffic share by region. Slices are drawn as one stroked
// circle each, offset around the ring by the running total of what came before,
// which is why the arcs butt up against each other with no gap.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./DonutChart.module.css";

const R = 60, CX = 80, CY = 80, STROKE = 22;
const CIRCUMFERENCE = 2 * Math.PI * R;

/** @param {{label: string, pct: number, color: string}[]} data */
export default function DonutChart({ data }) {
  let offset = 0;
  const slices = data.map((d) => {
    const dash = (d.pct / 100) * CIRCUMFERENCE;
    const slice = { ...d, dash, gap: CIRCUMFERENCE - dash, offset };
    offset += dash;
    return slice;
  });

  return (
    <div className={styles.donut}>
      <svg width="160" height="160" viewBox="0 0 160 160">
        <circle cx={CX} cy={CY} r={R} fill="none" stroke="#0d2318" strokeWidth={STROKE} />
        {slices.map((s, i) => (
          <circle
            key={i} cx={CX} cy={CY} r={R}
            fill="none" stroke={s.color} strokeWidth={STROKE}
            strokeDasharray={`${s.dash} ${s.gap}`}
            strokeDashoffset={-s.offset}
            strokeLinecap="butt"
            transform={`rotate(-90 ${CX} ${CY})`}
          />
        ))}
      </svg>

      <div className={styles.legend}>
        {data.map((d) => (
          <div key={d.label} className={styles.legendItem}>
            <span className={styles.legendDot} style={{ background: d.color }} />
            <span>{d.label} ({d.pct}%)</span>
          </div>
        ))}
      </div>
    </div>
  );
}
